// Race Code: cuenta atrás de drops ([data-rc-countdown]) y reloj por zona horaria ([data-rc-clock]).
// Sin dependencias. El servidor ya pinta los valores iniciales; esto solo los mantiene al día.
const pad = (n) => String(n).padStart(2, '0');

function startCountdown(el) {
  const target = Date.parse(el.dataset.rcCountdown);
  if (Number.isNaN(target)) return;

  const units = {};
  for (const node of el.querySelectorAll('[data-u]')) units[node.dataset.u] = node;
  const drop = el.closest('[data-rc-drop]');

  let timer = 0;
  const tick = () => {
    let s = Math.max(0, Math.floor((target - Date.now()) / 1000));
    if (s === 0) {
      drop?.setAttribute('data-state', 'live');
      clearInterval(timer);
    }
    const d = Math.floor(s / 86400);
    s -= d * 86400;
    const h = Math.floor(s / 3600);
    s -= h * 3600;
    const m = Math.floor(s / 60);
    s -= m * 60;
    if (units.d) units.d.textContent = pad(d);
    if (units.h) units.h.textContent = pad(h);
    if (units.m) units.m.textContent = pad(m);
    if (units.s) units.s.textContent = pad(s);
  };
  tick();
  timer = setInterval(tick, 1000);
}

function startClock(el) {
  const format = new Intl.DateTimeFormat('en-GB', { timeZone: el.dataset.rcClock, hour: '2-digit', minute: '2-digit' });
  const paint = () => (el.textContent = format.format(new Date()));
  paint();
  setInterval(paint, 30000);
}

function init(root = document) {
  for (const el of root.querySelectorAll('[data-rc-countdown]:not([data-rc-ready])')) {
    el.setAttribute('data-rc-ready', '');
    startCountdown(el);
  }
  for (const el of root.querySelectorAll('[data-rc-clock]:not([data-rc-ready])')) {
    el.setAttribute('data-rc-ready', '');
    startClock(el);
  }
}

init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
